<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bZ90iu/tc-custom/cover.jpg?1684979159315?1692044807376" alt="This image is the cover for the book The Things We Hide at Home"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Things We Hide at Home
      </h1>
      <p class="bookDescription body article font2">
        <p>The night Tenny first meets David at the Oubliette Club is when it all begins: the lewd pictures being posted through Tenny’s door, an intruder attempting to enter his home, the feeling of being watched and followed around. David is shy, timid and inexperienced when it comes to BDSM. He stands out like a sore thumb amongst the usual club-goers and Tenny is instantly drawn to his gentle nature.<br/><br/>However, David doesn’t gel well with Tenny’s overtly brash best friends, all of whom believe there’s something strange about him. Tenny understands David’s awkwardness, seeing something of his former self in him, and he quickly grows fond of his new friend.<br/><br/>In the meantime, Tenny does his best to deal with being stalked by an unknown stranger, wanting so hard to believe David is innocent.<br/><br/>Tenny fails to see how someone so quiet and fragile could ever do such horrible things, and is unable to stop from falling for him. Still, the unanswered questions, David’s evasiveness surrounding his past, and co-incidental circumstances leave Tenny no choice but to confront the truth.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nem Rowan
      </h2>
      
      <p class="authorDescription body article">Nem Rowan comes from the UK, but lives in Sweden with his wife and their girlfriend. He loves reading non-fiction and is fascinated by true crime and unsolved mysteries, especially missing persons cases and serial killers. Nem is also well-read in mythology and folk tales, particularly British and European folklore. He is a huge fan of horror movies and retrowave music.<br><br>Nem started writing when he was eleven years old and since then, he’s never looked back. Romance has always been his favourite genre after inheriting a box of Mills &amp; Boon novels from his grandma, but being a horror fan, there is always some way for him to work in a bit of that to make sure things don’t get too mushy.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6de7c187